import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'

import {
    faAngleDown,
    faAngleLeft,
    faAnglesLeft,
    faAnglesRight,
    faArrowDown,
    faArrowLeftLong,
    faArrowRight,
    faArrowRightLong,
    faArrowsUpDown,
    faArrowTrendUp,
    faArrowUp,
    faArrowUpRightFromSquare,
    faAtom,
    faBackwardStep,
    faBars,
    faBook,
    faBookmark,
    faBoxesStacked,
    faBuilding,
    faBullseye,
    faCalendar,
    faCaretDown,
    faCaretRight,
    faChartLine,
    faChartSimple,
    faCheck,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faCircle,
    faCircleArrowDown,
    faCircleArrowLeft,
    faCircleArrowRight,
    faCircleArrowUp,
    faCircleDollarToSlot,
    faCircleExclamation,
    faCircleInfo,
    faCircleMinus,
    faCirclePlus,
    faCircleQuestion,
    faCity,
    faCodeCompare,
    faCodeMerge,
    faCog,
    faCrown,
    faCubesStacked,
    faDiagramProject,
    faDiagramSuccessor,
    faDownload,
    faDumbbell,
    faEarthAmericas,
    faEdit,
    faEllipsisH,
    faEllipsisVertical,
    faEnvelope,
    faExclamation,
    faExpand,
    faExternalLink,
    faEye,
    faFileArrowDown,
    faFileArrowUp,
    faFileContract,
    faFileLines,
    faFilter,
    faFlag,
    faFont,
    faGaugeSimpleHigh,
    faGavel,
    faGear,
    faGlobe,
    faHashtag,
    faHeadset,
    faHome,
    faHourglassEnd,
    faLightbulb,
    faList,
    faLocationCrosshairs,
    faLock,
    faMagnifyingGlass,
    faMapMarkerAlt,
    faMicrochip,
    faMoneyBillWave,
    faMugHot,
    faPaperPlane,
    faPaperclip,
    faPencil,
    faPeopleGroup,
    faPhone,
    faPlus,
    faPrint,
    faPuzzlePiece,
    faRankingStar,
    faRectangleList,
    faRightToBracket,
    faRotate,
    faRuler,
    faSackDollar,
    faScroll,
    faSeedling,
    faShuffle,
    faSitemap,
    faSquareArrowUpRight,
    faStar,
    faStore,
    faTableCells,
    faTableCellsLarge,
    faTableColumns,
    faTableList,
    faThList,
    faThumbTack,
    faTimeline,
    faTrashCan,
    faTriangleExclamation,
    faTruck,
    faUser,
    faUserTie,
    faWandMagicSparkles,
    faWifi,
    faXmark,
} from '@fortawesome/free-solid-svg-icons'

import {
    faSwords,
    faViolin,
    faUserGroupCrown,
    faChartScatter,
    faWifiFair,
    faWifiWeak,
} from './customIcons'

// Pro-only glyphs mapped to the closest free equivalent, re-registered under the
// original icon name so existing `fa-*` references across the app keep resolving.
const alias = (icon, iconName) => ({ ...icon, iconName })

const faAtomSimple = alias(faAtom, 'atom-simple')
const faBarsFilter = alias(faFilter, 'bars-filter')
const faBooks = alias(faBook, 'books')
const faBuildings = alias(faBuilding, 'buildings')
const faPuzzle = alias(faPuzzlePiece, 'puzzle')
const faPuzzlePieceSimple = alias(faPuzzlePiece, 'puzzle-piece-simple')
const faLightbulbOn = alias(faLightbulb, 'lightbulb-on')
const faCoffeePot = alias(faMugHot, 'coffee-pot')
const faText = alias(faFont, 'text')
const faTruckContainer = alias(faTruck, 'truck-container')
const faMemo = alias(faFileLines, 'memo')
const faMerge = alias(faCodeMerge, 'merge')
const faColumns3 = alias(faTableColumns, 'columns-3')
const faObjectsColumn = alias(faTableColumns, 'objects-column')
const faTableLayout = alias(faTableCells, 'table-layout')
const faGrid2 = alias(faTableCells, 'grid-2')
const faListDropdown = alias(faList, 'list-dropdown')
const faListTree = alias(faList, 'list-tree')
const faSquareList = alias(faRectangleList, 'square-list')
const faListTimeline = alias(faTimeline, 'list-timeline')
const faTableTree = alias(faTableList, 'table-tree')
const faDiagramSubtask = alias(faDiagramProject, 'diagram-subtask')
const faChartNetwork = alias(faDiagramProject, 'chart-network')
const faChartLineUp = alias(faArrowTrendUp, 'chart-line-up')
const faChartTreeMap = alias(faTableCellsLarge, 'chart-tree-map')
const faConveyorBeltBoxes = alias(faBoxesStacked, 'conveyor-belt-boxes')
const faCircleDollar = alias(faCircleDollarToSlot, 'circle-dollar')
const faSparkles = alias(faWandMagicSparkles, 'sparkles')
const faArrowLeftFromLine = alias(faAnglesLeft, 'arrow-left-from-line')
const faArrowLeftToLine = alias(faAnglesLeft, 'arrow-left-to-line')
const faChevronsLeft = alias(faAnglesLeft, 'chevrons-left')
const faArrowRightFromLine = alias(faAnglesRight, 'arrow-right-from-line')
const faArrowRightToLine = alias(faAnglesRight, 'arrow-right-to-line')
const faArrowsFromLine = alias(faExpand, 'arrows-from-line')
const faArrowsMaximize = alias(faExpand, 'arrows-maximize')
const faArrowUpArrowDown = alias(faArrowsUpDown, 'arrow-up-arrow-down')
const faArrowLeftToBracket = alias(faRightToBracket, 'arrow-left-to-bracket')
const faArrowDownRight = alias(faArrowDown, 'arrow-down-right')
const faArrowUpRight = alias(faArrowUp, 'arrow-up-right')

library.add(
    // Free solid icons used as-is
    faAngleDown,
    faAngleLeft,
    faArrowLeftLong,
    faArrowRight,
    faArrowRightLong,
    faArrowUpRightFromSquare,
    faBackwardStep,
    faBars,
    faBook,
    faBookmark,
    faBoxesStacked,
    faBuilding,
    faBullseye,
    faCalendar,
    faCaretDown,
    faCaretRight,
    faChartLine,
    faChartSimple,
    faCheck,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faCircle,
    faCircleArrowDown,
    faCircleArrowLeft,
    faCircleArrowRight,
    faCircleArrowUp,
    faCircleExclamation,
    faCircleInfo,
    faCircleMinus,
    faCirclePlus,
    faCircleQuestion,
    faCity,
    faCodeCompare,
    faCog,
    faCrown,
    faCubesStacked,
    faDiagramSuccessor,
    faDownload,
    faDumbbell,
    faEarthAmericas,
    faEdit,
    faEllipsisH,
    faEllipsisVertical,
    faEnvelope,
    faExclamation,
    faExternalLink,
    faEye,
    faFileArrowDown,
    faFileArrowUp,
    faFileContract,
    faFileLines,
    faFlag,
    faGaugeSimpleHigh,
    faGavel,
    faGear,
    faGlobe,
    faHashtag,
    faHeadset,
    faHome,
    faHourglassEnd,
    faLocationCrosshairs,
    faLock,
    faMagnifyingGlass,
    faMapMarkerAlt,
    faMicrochip,
    faMoneyBillWave,
    faPaperPlane,
    faPaperclip,
    faPencil,
    faPeopleGroup,
    faPhone,
    faPlus,
    faPrint,
    faRankingStar,
    faRotate,
    faRuler,
    faSackDollar,
    faScroll,
    faSeedling,
    faShuffle,
    faSitemap,
    faSquareArrowUpRight,
    faStar,
    faStore,
    faTableList,
    faThList,
    faThumbTack,
    faTimeline,
    faTrashCan,
    faTriangleExclamation,
    faUser,
    faUserTie,
    faWifi,
    faXmark,
    // Pro-only glyphs remapped to free equivalents (registered under original names)
    faAtomSimple,
    faBarsFilter,
    faBooks,
    faBuildings,
    faPuzzle,
    faPuzzlePieceSimple,
    faLightbulbOn,
    faCoffeePot,
    faText,
    faTruckContainer,
    faMemo,
    faMerge,
    faColumns3,
    faObjectsColumn,
    faTableLayout,
    faGrid2,
    faListDropdown,
    faListTree,
    faSquareList,
    faListTimeline,
    faTableTree,
    faDiagramSubtask,
    faChartNetwork,
    faChartLineUp,
    faChartTreeMap,
    faConveyorBeltBoxes,
    faCircleDollar,
    faSparkles,
    faArrowLeftFromLine,
    faArrowLeftToLine,
    faChevronsLeft,
    faArrowRightFromLine,
    faArrowRightToLine,
    faArrowsFromLine,
    faArrowsMaximize,
    faArrowUpArrowDown,
    faArrowLeftToBracket,
    faArrowDownRight,
    faArrowUpRight,
    // Hand-authored custom SVGs (no acceptable free equivalent)
    faSwords,
    faViolin,
    faUserGroupCrown,
    faChartScatter,
    faWifiFair,
    faWifiWeak
)

export default FontAwesomeIcon
